import { store } from '@/state/store.js';

export class RequestManager {
  constructor() {
    this.pendingRequests = new Map();
  }

  patch(instance) {
    instance.interceptors.request.use(
      /**
       * Check and cancel matching pending xhr requests
       * @param {Object} config - axios config
       */
      (config) => {
        if (!config.cancelable) {
          return config;
        }

        const requestId = `${config.method}_${config.url}`;
        const controller = new AbortController();
        this.addPending(requestId, controller);

        // add the abort signal to the request
        // and the id so we can track it later
        config.signal = controller.signal;
        config.requestId = requestId;
        return config;
      }
    );

    instance.interceptors.response.use(
      /**
       * Clear any resource error notifications before returning the response
       * @TODO: is there a better way to do this without doing it globally here.
       * @param {Object} response - axios response
       * @returns {Object}
       */
      (response) => {
        store.dispatch('notifications/remove', store.getters['notifications/getNotificationsByType']('resource'));

        // Pull out the id we stored earlier
        // and clear out any matching pending requests
        const { requestId } = response.config;
        if (requestId) {
          this.removePending(requestId);
        }

        return response;
      },

      /**
       * Intercept 401 errors and reload so laravel can handle redirecting to login
       * @param {Object} error - axios response error
       */
      (error) => {
        if (error.response && error.response.status === 401) {
          return window.location.reload();
        }

        return Promise.reject(error);
      }
    );
  }

  addPending(requestId, controller) {
    this.cancelPending(requestId);
    this.pendingRequests.set(requestId, controller);
  }

  cancelPending(requestId) {
    if (this.pendingRequests.has(requestId)) {
      const controller = this.pendingRequests.get(requestId);
      this.removePending(requestId);
      controller.abort();
    }
  }

  removePending(requestId) {
    this.pendingRequests.delete(requestId);
  }
}
